import React, { useState } from 'react';
import ActivityItem from './ActivityItem';

function LatestActivities() {
  const [activeFilter, setActiveFilter] = useState('others');

  return (
    <div className="card border-0 shadow-sm mb-4" data-aos="fade-left">
      <div className="card-body p-4">
        <h6 className="mb-3 fw-bold">Latest activities</h6>
        
        {/* Activity Tabs */}
        <div className="d-flex gap-2 mb-3">
          <button className="btn btn-sm" style={{ 
            backgroundColor: activeFilter === 'claim' ? '#1f2937' : '#f3f4f6', 
            color: activeFilter === 'claim' ? 'white' : '#374151',
            border: 'none',
            fontWeight: '500'
          }}
          onClick={() => setActiveFilter('claim')}
          >
            Claim
          </button>
          <button className="btn btn-sm" style={{ 
            backgroundColor: activeFilter === 'others' ? '#1f2937' : '#f3f4f6', 
            color: activeFilter === 'others' ? 'white' : '#374151',
            border: 'none',
            fontWeight: '500'
          }}
          onClick={() => setActiveFilter('others')}
          >
            Others
          </button>
        </div>

        {/* Activity Item */}
        <ActivityItem
          title="New distributor activated!"
          description="Your account has been activated"
          timestamp="a month ago"
        />
      </div>
    </div>
  );
}

export default LatestActivities;